import { atom } from 'recoil';
import {
  getLocalStorageValue,
  LocalStorageKey,
} from '../../utils/localStorage/localStorage';

export const selectedLanguageState = atom<string>({
  key: 'languageState',
  default:
    process.env.REACT_APP_LANGUAGE ??
    getLocalStorageValue(LocalStorageKey.language) ??
    'GB',
});
